import React, { useState } from 'react';
import { ToastContainer, Bounce } from 'react-toastify';
import { Routes, Route, Link, Navigate } from 'react-router-dom';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from '@mui/material/CssBaseline';
import AppTheme from './shared-theme/AppTheme';

import Login from './pages/Login';
import Dashboard from './dashboard/Dashboard';

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#ff4081",
    },
  },
  typography: {
    fontFamily: "'Roboto', sans-serif",
  },
});

const App = (props) => {
  return (
    <ThemeProvider theme={theme}>
      <ToastContainer />
      <AppTheme {...props}>
        <CssBaseline enableColorScheme />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Dashboard />} />
        </Routes>
      </AppTheme>
    </ThemeProvider>

  );
}

export default App;
